import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import * as Sentry from "@sentry/react";

const NETWORK_OFFLINE_TOAST_ID = "network-offline";

export function useNetworkStatus() {
    const [isOnline, setIsOnline] = useState(true);

    useEffect(() => {
        const goOnline = () => {
            setIsOnline(navigator.onLine);
            toast.dismiss(NETWORK_OFFLINE_TOAST_ID);
        };
        const goOffline = () => {
            setIsOnline(false);
            if (!toast.isActive(NETWORK_OFFLINE_TOAST_ID)) {
                toast.error("Uh oh! We're detecting some network instability!! Please double check your internet", {
                    toastId: NETWORK_OFFLINE_TOAST_ID,
                });
            }

            Sentry.addBreadcrumb({
                category: "network",
                message: "Network instability detected",
                level: "info",
                data: {
                    isOnline: navigator.onLine,
                },
            });
        };

        window.addEventListener("online", goOnline);
        window.addEventListener("offline", goOffline);

        return () => {
            window.removeEventListener("online", goOnline);
            window.removeEventListener("offline", goOffline);
        };
    }, []);

    return isOnline;
}
